import { z } from "zod";

// Validation schemas -- projected from spec domain model

export const createCourtSchema = z.object({
  name: z.string().min(1, "Name is required").max(255),
  court_type_id: z.string().min(1, "Court type is required"),
  template_id: z.string().min(1).optional(),
});

export const updateCourtSchema = z.object({
  name: z.string().min(1, "Name is required").max(255).optional(),
  court_type_id: z.string().min(1, "Court type is required").optional(),
});

export type CreateCourtInput = z.infer<typeof createCourtSchema>;
export type UpdateCourtInput = z.infer<typeof updateCourtSchema>;
